import styled from 'styled-components'

export const Container = styled.div`
  padding: ${({ theme }) => theme.spacing.km12};
`

export const Header = styled.div``

export const Body = styled.div`
  padding-bottom: calc(${({ theme }) => theme.spacing.km16} + ${({ theme }) => theme.spacing.km6});
  width: 100%;
`

export const Footer = styled.div`
  position: fixed;
  bottom: calc(${({ theme }) => theme.spacing.km16} + ${({ theme }) => theme.spacing.km6});
  right: ${({ theme }) => theme.spacing.km12};
`

export const Subtitle = styled.div`
  padding: ${({ theme }) => theme.spacing.km2} ${({ theme }) => theme.spacing.km0} ${({ theme }) => theme.spacing.km14};
`

export const SearchResult = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.km3};
`
